import script from "./Searchbar.vue?vue&type=script&setup=true&lang=js"
export * from "./Searchbar.vue?vue&type=script&setup=true&lang=js"

import "./Searchbar.vue?vue&type=style&index=0&id=a133d8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a133d8b6"]])

export default __exports__